export default __webpack_public_path__ + "static/media/033-bm.09e71224.webp";